import { configureStore, combineReducers } from '@reduxjs/toolkit'
import storage from 'redux-persist/lib/storage'
import { persistReducer, persistStore } from 'redux-persist'
import { authRedux, googleRedux, apiRedux } from './slices'

const rootReducer = combineReducers({
  google: googleRedux.reducer,
  auth: authRedux.reducer,
  api: apiRedux.reducer
})

const persistedReducer = persistReducer({
  key: 'root',
  storage,
  // Auth is session-scoped via Firebase browserSessionPersistence — do not
  // rehydrate long-lived JWTs from localStorage.
  whitelist: []
}, rootReducer)

const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) => getDefaultMiddleware({ serializableCheck: false })
})

const persistor = persistStore(store)

export { store, persistor }
export const { actions: googleActions } = googleRedux
export const { actions: authActions } = authRedux
export const { actions: apiActions } = apiRedux
